import React, { useEffect, useState } from 'react';
import { capitalize, isEmpty, startCase, camelCase } from 'lodash';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import swal from 'sweetalert';
import docImage from '../../../assets/img/doc.png';
import AppLoader from '../../components/loaders/AppLoader';
import { hideLoading, showLoading } from '../../redux/loader/LoaderActions';
import { GET, POST, DELETE } from '../../services/rest.service';
import { showModal } from '../../redux/error/ErrorAction';
import {
  weightFormat,
  accessGeneralOrCargoType,
  getJobStatus,
  getPortName,
  fetchPrivateDocument,
  downloadPrivateDocument,
} from '../../helpers/utils';
import { LeftArrowSvg } from '../../components/UI/CommanUI';
import Chat from '../../components/UI/Chat';
import { showDocumentModal } from '../../redux/user/UserActions';
import RejectModal from '../../components/Modals/RejectModal';
import { useChat } from '../../helpers/customHooks';
import JobUnbundleModal from './JobUnbundleModal';
import ExtendPaymentTimeModal from './ExtendPaymentTimeModal';
import JobApproveModal from './JobApproveModal';
import AssignAgentToJobModal from './AssignAgentToJobModal';
import DocumentUploadForm from './DocumentUploadForm';

const NewJobDetail = (props) => {
  const dispatch = useDispatch();
  const serviceData = useSelector((state) => state.enumData);

  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [unBundleModal, setUnBundleModall] = useState(false);
  const [jobDetails, setJobDetails] = useState({});
  const [unreadCount, setUnreadCount] = useState(0);
  const [extendTimeModal, setExtendTimeModal] = useState(false);
  const [assignAgentModal, setAssignAgentModal] = useState(false);

  const [jobStatus, setJobStatus] = useState('');
  const [jobClearingPort, setClearingPort] = useState('');
  const [pickupPort, setPickupPort] = useState('');

  const toggleApproveModal = () => setApproveModal((s) => !s);
  const toggleUnBundelModal = () => setUnBundleModall((s) => !s);
  const toggleRejectModal = () => setRejectModal((s) => !s);
  const toggleExtendTimeModal = () => setExtendTimeModal((s) => !s);
  const toggleAssignAgentModal = () => setAssignAgentModal((s) => !s);

  const showDoc = (docc) => dispatch(showDocumentModal(docc));

  /**
   * The Bill of Lading is served from a private disk behind an authenticated
   * route, so it is fetched with the bearer token and shown as a blob. Files
   * uploaded before that disk existed are still public and pass through.
   */
  const showPrivateDoc = async (docs) => {
    const { src, message } = await fetchPrivateDocument(docs?.lading_url, docs?.lading_is_legacy);
    if (src) {
      dispatch(showDocumentModal(src));
    } else {
      dispatch(showModal(message || 'This document could not be opened.'));
    }
  };

  // Saving is a second action on the same permission: fetchPrivateDocument has
  // already been through the server's check by the time a file exists to write.
  const savePrivateDoc = async (docs) => {
    const { ok, message } = await downloadPrivateDocument(docs);
    if (!ok) {
      dispatch(showModal(message || 'This document could not be downloaded.'));
    }
  };

  useEffect(() => {
    getJobDetails();
  }, []);

  useEffect(() => {
    setJobStatus(getJobStatus(jobDetails, serviceData));
    // Rendered as stored. startCase(camelCase()) mangled the customs command
    // names — "Ogun II" became "Ogun Ii" and "Abuja (FCT)" became "Abuja Fct".
    setClearingPort(getPortName(jobDetails?.clearing_discharge_port, serviceData));
    setPickupPort(getPortName(jobDetails?.port_of_discharge, serviceData));
  }, [jobDetails?.port_of_discharg, jobDetails?.clearing_discharge_port, serviceData?.ports]);

  const getJobDetails = () => {
    const id = props.match.params.id;
    dispatch(showLoading());
    GET(`/jobs/getDetails/${id}`)
      .then(({ data }) => {
        // privateJobDocs rides alongside the job rather than on it, since the
        // Bill of Lading is no longer serialised on the model. Folded in so the
        // rest of this screen keeps reading one object.
        setJobDetails({ ...data.job, privateJobDocs: data.privateJobDocs });
        console.log(data.job.no_of_containers);
        dispatch(hideLoading());
      })
      .catch((err) => {
        dispatch(showModal(err.message));
        dispatch(hideLoading());
        props.history.goBack();
      });
  };

  // CHAT Related code -- starts here
  const { user } = useSelector((state) => state.user);
  const job_id = props.match.params.id;
  const userIsWorkSupervisor = user.type === 'work_supervisor';

  const [chatbox, setChatbox] = useState(false);
  const [chatlist, setChatlist] = useState([]);
  const [msg, setMsg] = useState('');

  const chatName = user.type === 'application_client' ? 'Us' : 'Client';
  const chatBlockId = chatName === 'Client' ? 'chat-tops' : 'chat-top';

  const showUpdateJob =
    jobDetails.clearing_status === '6' ||
    jobDetails.forwarding_status === '6' ||
    jobDetails.clearing_status === '3' ||
    jobDetails.forwarding_status === '3' ||
    jobDetails.clearing_status === '11' ||
    jobDetails.clearing_status === '12';

  const handleChatEvent = (data1) => {
    if (data1.chat_type === 'client') {
      if (!chatbox) {
        setUnreadCount((prevState) => prevState + 1);
      }
      setChatlist((prevState) => [...prevState, data1]);
      const objDiv = document.getElementById(chatBlockId);
      if (objDiv) {
        objDiv.scrollTop = objDiv.scrollHeight;
      }
    }
    dispatch(showModal('you have a new message', true));
  };
  useChat(user.uuid, chatbox, handleChatEvent);

  const getChat = () => {
    GET(`/chats/getByJob/${job_id}`)
      .then(({ data }) => {
        if (user.type === 'application_client') {
          const oc = data.chats.operator?.length > 0 ? data.chats.operator.reverse() : [];
          setChatlist(oc);
        } else {
          const cc = data.chats.client?.length > 0 ? data.chats.client.reverse() : [];
          setChatlist(cc);
        }
        const objDiv = document.getElementById(chatBlockId);
        if (objDiv) {
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      })
      .catch((err) => {
        dispatch(showModal(err.message));
      });
  };

  const chatToggle = () => {
    if (!chatbox) {
      getChat();
      setUnreadCount(0);
    }
    setChatbox(!chatbox);
  };

  const sendMessage = () => {
    let message = 'Hi';
    if (!isEmpty(msg)) {
      message = msg;
    }

    const payLoad = {
      job_uuid: job_id,
      sender_uuid: user.uuid,
      message: message,
      chat_type: 'client',
    };
    if (user.type === 'application_client') {
      payLoad.receiver_uuid = jobDetails.operator_uuid;
    } else if (user.type === 'managenmnt_operator') {
      payLoad.receiver_uuid = jobDetails.created_by;
    }

    POST(`/chats/addMessage`, payLoad)
      .then(({ data }) => {
        setChatlist((prevState) => [...prevState, data.chat]);
        const objDiv = document.getElementById(chatBlockId);
        if (objDiv) {
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      })
      .catch((err) => {
        dispatch(showModal(err.message));
      });
  };
  const sendButton = () => {
    sendMessage();
    setMsg('');
  };

  const handleTextChange = (e) => {
    if (e.key === 'Enter') {
      sendMessage();
      setMsg('');
    }
  };
  const handleOnChange = (e) => {
    setMsg(e.target.value);
  };
  // CHAT Related code -- ends here

  const handleJobReject = (values) => {
    dispatch(showLoading());
    POST(`/jobs/operatorRejectJob`, {
      job_uuid: jobDetails.uuid,
      comment: values.comment,
    })
      .then(({ data }) => {
        let jobData = { ...jobDetails, clearing_status: data.job.clearing_status };
        setJobDetails(jobData);
        dispatch(hideLoading());
        dispatch(showModal(`Service rejected successfully!`, true));
        props.history.goBack();
      })
      .catch((err) => {
        dispatch(hideLoading());
        dispatch(showModal(err.message));
      });
  };

  const handleDeleteJob = () => {
    swal({
      title: 'Are you sure?',
      text: `Are you sure you want to Delete this job?`,
      icon: 'warning',
      buttons: ['No', 'Yes'],
    }).then((result) => {
      if (result) {
        const id = props.match.params.id;
        dispatch(showLoading());
        DELETE(`/jobs/${id}`)
          .then(() => {
            dispatch(showModal('Job Deleted Sucessfully!', true));
            dispatch(hideLoading());
            props.history.goBack();
          })
          .catch((err) => {
            dispatch(hideLoading());
            dispatch(showModal(err.message));
          });
      }
    });
  };

  const onJobUnbundle = () => {
    getJobDetails();
    toggleUnBundelModal();
  };

  const onExtendJobTime = () => {
    getJobDetails();
    toggleExtendTimeModal();
  };

  const onJobApprove = (data) => {
    setJobDetails(data);
    toggleApproveModal();
    props.history.goBack();
  };

  const onAssignAgentToJob = () => {
    getJobDetails();
    toggleAssignAgentModal();
  };

  const canApprove = () => {
    if (
      jobDetails.has_forwarding === 1 &&
      jobDetails.tonnage &&
      jobDetails.children_packages.length <= 0
    ) {
      return true;
    }

    if (
      jobDetails.no_of_containers !== null &&
      jobDetails.no_of_containers <= 0 &&
      !jobDetails.tonnage
    ) {
      return true;
    }

    if (jobDetails.children_packages.length > 0) {
      return true;
    }

    if (jobDetails.has_forwarding === 0) {
      return true;
    }

    return false;
  };

  if (!jobDetails || isEmpty(serviceData)) {
    return <AppLoader />;
  }

  return (
    <>
      <div id="tabblock1" className="tabcontent">
        <div
          className="bodycont"
          style={{
            background: '#f8f9fa',
            minHeight: '100vh',
            padding: '120px 2rem 2rem',
            maxWidth: '100vw',
            overflowX: 'hidden',
          }}
        >
          {/* Page Header with Gradient */}
          <div
            className="mb-4"
            style={{
              background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
              padding: '2rem 2rem 1.5rem',
              borderRadius: '16px',
              color: 'white',
              boxShadow: '0 8px 30px rgba(0,118,121,0.3)',
              width: '100%',
              boxSizing: 'border-box',
              margin: '0 auto',
              position: 'relative',
              zIndex: 1,
            }}
          >
            <div className="w-100 text-center">
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1.5rem',
                  gap: '0.75rem',
                }}
              >
                <span
                  onClick={() => props.history.goBack()}
                  style={{ cursor: 'pointer', flexShrink: 0 }}
                >
                  <LeftArrowSvg />
                </span>
                <h2
                  style={{
                    margin: 0,
                    fontSize: '2.5rem',
                    fontWeight: '800',
                    lineHeight: '1.2',
                    flex: '1 1 auto',
                    minWidth: '200px',
                    color: 'white',
                  }}
                >
                  <i className="fa fa-briefcase" style={{ marginRight: '12px' }}></i>
                  Job Details
                </h2>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '0.75rem',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {jobDetails.job_type_tags &&
                  jobDetails.job_type_tags.map((y, i) => (
                    <span
                      key={i}
                      style={{
                        display: 'inline-block',
                        backgroundColor: 'rgba(255,255,255,0.25)',
                        backdropFilter: 'blur(10px)',
                        color: '#ffffff',
                        fontSize: '1.4rem',
                        fontWeight: '700',
                        border: '2px solid rgba(255,255,255,0.5)',
                        padding: '0.7rem 1.5rem',
                        borderRadius: '0.5rem',
                        lineHeight: '1.3',
                        letterSpacing: '0.5px',
                      }}
                    >
                      {capitalize(y === 'forwarding' ? 'Transport' : y)} Job
                    </span>
                  ))}
                <span
                  style={{
                    display: 'inline-block',
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    color: '#007679',
                    fontSize: '1.4rem',
                    fontWeight: '700',
                    padding: '0.7rem 1.5rem',
                    borderRadius: '0.5rem',
                    lineHeight: '1.3',
                    letterSpacing: '0.5px',
                  }}
                >
                  {jobDetails.job_id
                    ? `Job ID: ${jobDetails.job_id}-${jobDetails.is_forwarding_only ? 'T' : 'C'}`
                    : 'N/A'}
                </span>
              </div>
            </div>
          </div>

          <div className="servicetab">
            <div className="operator-info">
              <div>
                {/* Email Not Verified Alert */}
                {jobDetails.client && jobDetails.client.email_verified_at == null && (
                  <div
                    className="alert alert-danger mb-4"
                    style={{ fontSize: '1.2rem', fontWeight: '600', padding: '1.5rem' }}
                  >
                    <i className="fa fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                    Email is not verified yet
                  </div>
                )}

                {/* Importer Details Card */}
                {jobDetails?.client && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #007679',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-user"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Importer Details
                      </h4>
                    </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                      <div className="row g-4">
                        {jobDetails?.client?.first_name && (
                          <div className="col-md-6">
                            <div
                              className="p-4 rounded-4"
                              style={{
                                background: 'linear-gradient(135deg, #e8f5f5 0%, #d4efef 100%)',
                                borderLeft: '6px solid #007679',
                                boxShadow: '0 2px 8px rgba(0,118,121,0.1)',
                              }}
                            >
                              <p
                                className="mb-2"
                                style={{
                                  fontSize: '1.4rem',
                                  fontWeight: '700',
                                  color: '#007679',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                }}
                              >
                                <i className="fa fa-user" style={{ marginRight: '8px' }}></i>Name
                              </p>
                              <p
                                className="mb-0"
                                style={{ fontSize: '1.5rem', color: '#004d4d', fontWeight: '700' }}
                              >
                                {jobDetails.client.first_name} {jobDetails.client.last_name}
                              </p>
                            </div>
                          </div>
                        )}
                        <div className="col-md-6">
                          <div
                            className="p-4 rounded-4"
                            style={{
                              background: 'linear-gradient(135deg, #f0f9f9 0%, #e8f5f5 100%)',
                              borderLeft: '6px solid #01a8af',
                              boxShadow: '0 2px 8px rgba(1,168,175,0.1)',
                            }}
                          >
                            <p
                              className="mb-2"
                              style={{
                                fontSize: '1.4rem',
                                fontWeight: '700',
                                color: '#01a8af',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                              }}
                            >
                              <i className="fa fa-envelope" style={{ marginRight: '8px' }}></i>Email
                            </p>
                            <p
                              className="mb-0"
                              style={{ fontSize: '1.5rem', color: '#004d4d', fontWeight: '700' }}
                            >
                              {jobDetails?.client?.email}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            className="p-4 rounded-4"
                            style={{
                              background: 'linear-gradient(135deg, #f0f9f9 0%, #e8f5f5 100%)',
                              borderLeft: '6px solid #1daeb2',
                              boxShadow: '0 2px 8px rgba(29,174,178,0.1)',
                            }}
                          >
                            <p
                              className="mb-2"
                              style={{
                                fontSize: '1.4rem',
                                fontWeight: '700',
                                color: '#1daeb2',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                              }}
                            >
                              <i className="fa fa-id-badge" style={{ marginRight: '8px' }}></i>User
                              ID
                            </p>
                            <p
                              className="mb-0"
                              style={{ fontSize: '1.5rem', color: '#004d4d', fontWeight: '700' }}
                            >
                              {jobDetails?.client?.user_id}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            className="p-4 rounded-4"
                            style={{
                              background: 'linear-gradient(135deg, #f0f9f9 0%, #e8f5f5 100%)',
                              borderLeft: '6px solid #29bec1',
                              boxShadow: '0 2px 8px rgba(41,190,193,0.1)',
                            }}
                          >
                            <p
                              className="mb-2"
                              style={{
                                fontSize: '1.4rem',
                                fontWeight: '700',
                                color: '#29bec1',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                              }}
                            >
                              <i className="fa fa-phone" style={{ marginRight: '8px' }}></i>Phone
                              Number
                            </p>
                            <p
                              className="mb-0"
                              style={{ fontSize: '1.5rem', color: '#004d4d', fontWeight: '700' }}
                            >
                              {jobDetails?.client?.mobile_number}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}



                {/* Clearing Agent Info */}
                {/* {jobDetails?.clearing_agent?.first_name && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #007679',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-user-circle"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Clearing Details
                      </h4>
                    </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                      <div className="row g-4">
                        <div className="col-md-6">
                          <div
                            className="p-4 rounded-3"
                            style={{
                              background: 'linear-gradient(135deg, #e8f5f5 0%, #d4efef 100%)',
                              borderLeft: '6px solid #007679',
                            }}
                          >
                            <p
                              className="mb-2"
                              style={{
                                fontSize: '1.4rem',
                                fontWeight: '700',
                                color: '#007679',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                              }}
                            >
                              <i className="fa fa-user" style={{ marginRight: '8px' }}></i>Clearing
                              Agent
                            </p>
                            <h3
                              className="mb-0"
                              style={{ color: '#004d4d', fontSize: '1.5rem', fontWeight: '700' }}
                            >
                              {jobDetails.clearing_agent.first_name}{' '}
                              {jobDetails.clearing_agent.last_name}
                            </h3>
                          </div>
                        </div>
                        {jobDetails?.clearing_discharge_port && (
                          <div className="col-md-6">
                            <div
                              className="p-4 rounded-3"
                              style={{
                                background: 'linear-gradient(135deg, #e0f7f7 0%, #d0efef 100%)',
                                borderLeft: '6px solid #01a8af',
                              }}
                            >
                              <p
                                className="mb-2"
                                style={{
                                  fontSize: '1.4rem',
                                  fontWeight: '700',
                                  color: '#01a8af',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                }}
                              >
                                <i className="fa fa-ship" style={{ marginRight: '8px' }}></i>Port of
                                Discharge
                              </p>
                              <h3
                                className="mb-0"
                                style={{ color: '#015f5f', fontSize: '1.5rem', fontWeight: '700' }}
                              >
                                {jobClearingPort}
                              </h3>
                            </div>
                          </div>
                        )}
                        {jobDetails?.port_of_discharge && (
                          <div className="col-md-6">
                            <div
                              className="p-4 rounded-3"
                              style={{
                                background: 'linear-gradient(135deg, #e8f8f8 0%, #d8f0f0 100%)',
                                borderLeft: '6px solid #1daeb2',
                              }}
                            >
                              <p
                                className="mb-2"
                                style={{
                                  fontSize: '1.4rem',
                                  fontWeight: '700',
                                  color: '#1daeb2',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                }}
                              >
                                <i className="fa fa-map-marker" style={{ marginRight: '8px' }}></i>
                                Pick-up Location
                              </p>
                              <h3
                                className="mb-0"
                                style={{ color: '#1a8a8d', fontSize: '1.5rem', fontWeight: '700' }}
                              >
                                {pickupPort}
                              </h3>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )} */}

                {/* Rejection Comment */}
                {jobDetails.operator_comment && (
                  <div
                    className="alert alert-danger mb-4"
                    style={{ fontSize: '1.1rem', fontWeight: '600', padding: '1.5rem' }}
                  >
                    <i className="fa fa-exclamation-circle" style={{ marginRight: '8px' }}></i>
                    <strong>Reason for Rejection:</strong> {jobDetails.operator_comment}
                  </div>
                )}

                {/* Vehicle Category Details */}
                {jobDetails.category === 1 && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #01a8af',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-car"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Vehicle Details
                      </h4>
                    </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                        <div className="w-100">
                            <div className="row g-4 mb-4">
                              {/* 1. Cargo Category */}
                              <div className={serviceData?.job?.vehicle_type?.[jobDetails.type]?.toLowerCase() === 'roro' ? "col-md-6" : "col-md-4"}>
                                <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,118,121,0.15)', overflow: 'hidden' }}>
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center">
                                      <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', flexShrink: 0 }}>
                                        <i className="fa fa-list text-white" style={{ fontSize: '1.8rem' }}></i>
                                      </div>
                                      <div>
                                        <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Cargo Category</p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.5rem' }}>
                                          {serviceData?.job?.category?.[jobDetails.category] ? capitalize(serviceData.job.category[jobDetails.category]) : 'N/A'}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* 2. Type of Vehicle */}
                              <div className={serviceData?.job?.vehicle_type?.[jobDetails.type]?.toLowerCase() === 'roro' ? "col-md-6" : "col-md-4"}>
                                <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(1,168,175,0.15)', overflow: 'hidden' }}>
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-center">
                                      <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)', flexShrink: 0 }}>
                                        <i className="fa fa-truck text-white" style={{ fontSize: '1.8rem' }}></i>
                                      </div>
                                      <div>
                                        <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Type of Vehicle</p>
                                        <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.5rem' }}>
                                          {serviceData?.job?.vehicle_type?.[jobDetails.type] ? capitalize(serviceData.job.vehicle_type[jobDetails.type]) : 'N/A'}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* 3. No of Containers */}
                              {serviceData?.job?.vehicle_type?.[jobDetails.type]?.toLowerCase() !== 'roro' && (
                                <div className="col-md-4">
                                  <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(29,174,178,0.15)', overflow: 'hidden' }}>
                                    <div className="card-body p-4">
                                      <div className="d-flex align-items-center">
                                        <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)', flexShrink: 0 }}>
                                          <i className="fa fa-cubes text-white" style={{ fontSize: '1.8rem' }}></i>
                                        </div>
                                        <div>
                                          <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>No of Containers</p>
                                          <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>
                                            {jobDetails?.containers?.length || jobDetails?.vehicles?.length || jobDetails?.no_of_containers || 0}
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                        <div className="row g-4 mt-2">
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,118,121,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-info-circle text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Status</p>
                                    <h4 className="mb-0" style={{ color: '#007679', fontSize: '1.5rem', fontWeight: '700' }}>{getJobStatus(jobDetails, serviceData)}</h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(1,168,175,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-calendar text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Expected Arrival</p>
                                    <h4 className="mb-0" style={{ color: '#01a8af', fontSize: '1.5rem', fontWeight: '700' }}>{moment(jobDetails.date_of_arrival).format('DD MMM YYYY') || 'N/A'}</h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(29,174,178,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-ship text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Port of Discharge</p>
                                    <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>{jobClearingPort}</h4>
                                    {/* The operator has to set these before the job can be approved,
                                        so they belong on the screen where the job is reviewed. */}
                                    {jobDetails?.terminal_display && (
                                      <>
                                        <p className="text-muted mb-1 mt-3" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Terminal</p>
                                        <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>{jobDetails.terminal_display}</h4>
                                      </>
                                    )}
                                    {jobDetails?.shipping_line_display && (
                                      <>
                                        <p className="text-muted mb-1 mt-3" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Shipping Line</p>
                                        <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>{jobDetails.shipping_line_display}</h4>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {jobDetails.containers && jobDetails.containers.length > 0 && (
                        <div className="mt-4">
                          {jobDetails.containers.map((x, index) => (
                            <div key={index} className={index > 0 ? 'mt-5' : ''}>
                              <div className="p-3 mb-4 rounded-4" style={{ background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white', boxShadow: '0 4px 12px rgba(0,118,121,0.2)' }}>
                                <h4
                                  className="fw-bold mb-0"
                                  style={{ color: '#ffffff', fontSize: '1.5rem' }}
                                >
                                  <i className="fa fa-cube me-2"></i>Container {index + 1}
                                </h4>
                              </div>

                              <div className="row g-4 mb-4">
                                <div className="col-md-4">
                                  <div className="p-4 rounded-4 h-100 text-center" style={{ background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white' }}>
                                    <p className="mb-2" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                      <i className="fa fa-arrows-alt me-2"></i>Size of Container
                                    </p>
                                    <h3 className="mb-0 fw-bold" style={{ fontSize: '1.5rem', color: 'white' }}>
                                      {x.size_of_container || x.size || x.vehicles?.[0]?.size_of_container || jobDetails.size || 'N/A'}
                                    </h3>
                                    <p className="mb-0 mt-1" style={{ fontSize: '1rem', opacity: 0.9 }}>
                                      Type: {x.container_type || x.vehicles?.[0]?.container_type || 'N/A'}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="p-4 rounded-4 h-100 text-center" style={{ background: 'linear-gradient(135deg, #e8f5f5 0%, #d4efef 100%)', borderLeft: '6px solid #1daeb2' }}>
                                    <p className="mb-2" style={{ fontSize: '1.4rem', fontWeight: '700', color: '#1daeb2', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                      <i className="fa fa-car me-2"></i>Number of Vehicles
                                    </p>
                                    <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.5rem' }}>
                                      {x.vehicles?.length || 0}
                                    </h4>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="p-4 rounded-4 h-100 text-center" style={{ background: 'linear-gradient(135deg, #f0f9f9 0%, #e0f2f2 100%)', borderLeft: '6px solid #01a8af' }}>
                                    <p className="mb-2" style={{ fontSize: '1.4rem', fontWeight: '700', color: '#01a8af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                      <i className="fa fa-list me-2"></i>Description of added items
                                    </p>
                                    <h3 className="mb-0 fw-bold" style={{ fontSize: '1.5rem', color: '#004d4d' }}>
                                      {x.load_description || x.item_name || 'N/A'}
                                    </h3>
                                  </div>
                                </div>
                              </div>

                              {x.vehicles && x.vehicles.length > 0 && (
                                <div className="row g-4">
                                  {x.vehicles.map((v, i) => (
                                    <div className="col-lg-6 col-sm-12" key={i}>
                                      <div
                                        className="card border-0 h-100"
                                        style={{
                                          background: '#ffffff',
                                          borderRadius: '20px',
                                          boxShadow: '0 4px 15px rgba(1,168,175,0.15)',
                                          overflow: 'hidden',
                                        }}
                                      >
                                        <div
                                          className="card-header"
                                          style={{
                                            background:
                                              'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)',
                                            padding: '1.25rem 1.5rem',
                                            border: 'none',
                                          }}
                                        >
                                          <div className="d-flex justify-content-between align-items-center">
                                            <h5
                                              className="mb-0 fw-bold text-white"
                                              style={{ fontSize: '1.3rem' }}
                                            >
                                              {jobDetails.type === 1
                                                ? 'Vehicle Information'
                                                : `Vehicle ${i + 1}`}
                                            </h5>
                                            <span
                                              className="badge bg-white"
                                              style={{
                                                color: '#01a8af',
                                                fontSize: '1rem',
                                                fontWeight: '700',
                                                padding: '0.5rem 1rem',
                                              }}
                                            >
                                              Vehicle #{i + 1}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="card-body p-4">
                                          <div className="row g-3">
                                            <div className="col-6">
                                              <div
                                                className="p-3 rounded-4 h-100"
                                                style={{
                                                  background: '#f8f9fa',
                                                  border: '1px solid #eee',
                                                }}
                                              >
                                                <p
                                                  className="mb-1"
                                                  style={{
                                                    fontSize: '1.4rem',
                                                    fontWeight: '700',
                                                    color: '#01a8af',
                                                    textTransform: 'uppercase',
                                                  }}
                                                >
                                                  Brand
                                                </p>
                                                <p
                                                  className="mb-0 fw-bold"
                                                  style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                                >
                                                  {v.brand}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-6">
                                              <div
                                                className="p-3 rounded-4 h-100"
                                                style={{
                                                  background: '#f8f9fa',
                                                  border: '1px solid #eee',
                                                }}
                                              >
                                                <p
                                                  className="mb-1"
                                                  style={{
                                                    fontSize: '1.4rem',
                                                    fontWeight: '700',
                                                    color: '#01a8af',
                                                    textTransform: 'uppercase',
                                                  }}
                                                >
                                                  Year
                                                </p>
                                                <p
                                                  className="mb-0 fw-bold"
                                                  style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                                >
                                                  {v.year}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-6">
                                              <div
                                                className="p-3 rounded-4 h-100"
                                                style={{
                                                  background: '#f8f9fa',
                                                  border: '1px solid #eee',
                                                }}
                                              >
                                                <p
                                                  className="mb-1"
                                                  style={{
                                                    fontSize: '1.4rem',
                                                    fontWeight: '700',
                                                    color: '#01a8af',
                                                    textTransform: 'uppercase',
                                                  }}
                                                >
                                                  Model
                                                </p>
                                                <p
                                                  className="mb-0 fw-bold"
                                                  style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                                >
                                                  {v.model}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-6">
                                              <div
                                                className="p-3 rounded-4 h-100"
                                                style={{
                                                  background: '#f8f9fa',
                                                  border: '1px solid #eee',
                                                }}
                                              >
                                                <p
                                                  className="mb-1"
                                                  style={{
                                                    fontSize: '1.4rem',
                                                    fontWeight: '700',
                                                    color: '#01a8af',
                                                    textTransform: 'uppercase',
                                                  }}
                                                >
                                                  Condition
                                                </p>
                                                <p
                                                  className="mb-0 fw-bold"
                                                  style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                                >
                                                  {capitalize(
                                                    serviceData.job.vehicle_state[v.vehicle_state],
                                                  )}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-12">
                                              <div
                                                className="p-3 rounded-4"
                                                style={{
                                                  background: '#f8f9fa',
                                                  border: '1px solid #eee',
                                                }}
                                              >
                                                <p
                                                  className="mb-1"
                                                  style={{
                                                    fontSize: '1.4rem',
                                                    fontWeight: '700',
                                                    color: '#01a8af',
                                                    textTransform: 'uppercase',
                                                  }}
                                                >
                                                  VREG Number
                                                </p>
                                                <p
                                                  className="mb-0 fw-bold"
                                                  style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                                >
                                                  {v.vreg_no || 'N/A'}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {jobDetails.category === 2 && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #01a8af',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-cubes"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Cargo Details
                      </h4>
                    </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                      <div className="w-100">
                        <div className="row g-4 mb-4">
                          {/* 1. Cargo Category */}
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,118,121,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-list text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Cargo Category</p>
                                    <h4 className="mb-0" style={{ color: '#007679', fontSize: '1.5rem', fontWeight: '700' }}>
                                      {serviceData?.job?.category?.[jobDetails.category] ? capitalize(serviceData.job.category[jobDetails.category]) : 'N/A'}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* 2. Type of Cargo */}
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(1,168,175,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-cube text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Type of Cargo</p>
                                    <h4 className="mb-0" style={{ color: '#01a8af', fontSize: '1.5rem', fontWeight: '700' }}>
                                      {accessGeneralOrCargoType(jobDetails, serviceData)}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* 3. No of Containers */}
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(29,174,178,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-cubes text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>No of Containers</p>
                                    <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>
                                      {jobDetails?.no_of_containers || jobDetails?.containers?.length || 0}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row g-4 mt-2">
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,118,121,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-info-circle text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Status</p>
                                    <h4 className="mb-0" style={{ color: '#007679', fontSize: '1.5rem', fontWeight: '700' }}>{getJobStatus(jobDetails, serviceData)}</h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(1,168,175,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-calendar text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Expected Arrival</p>
                                    <h4 className="mb-0" style={{ color: '#01a8af', fontSize: '1.5rem', fontWeight: '700' }}>{moment(jobDetails.date_of_arrival).format('DD MMM YYYY') || 'N/A'}</h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(29,174,178,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-ship text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Port of Discharge</p>
                                    <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>{jobClearingPort}</h4>
                                    {jobDetails?.terminal_display && (
                                      <>
                                        <p className="text-muted mb-1 mt-3" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Terminal</p>
                                        <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>{jobDetails.terminal_display}</h4>
                                      </>
                                    )}
                                    {jobDetails?.shipping_line_display && (
                                      <>
                                        <p className="text-muted mb-1 mt-3" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Shipping Line</p>
                                        <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>{jobDetails.shipping_line_display}</h4>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {jobDetails.containers && jobDetails.containers.length > 0 && (
                        <div className="mt-4">
                          {jobDetails.containers.map((x, index) => (
                            <div key={index} className={index > 0 ? 'mt-5' : ''}>
                              <div className="p-3 mb-4 rounded-4" style={{ background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white', boxShadow: '0 4px 12px rgba(0,118,121,0.2)' }}>
                                <h4
                                  className="fw-bold mb-0"
                                  style={{ color: '#ffffff', fontSize: '1.5rem' }}
                                >
                                  <i className="fa fa-cube me-2"></i>Container {index + 1}
                                </h4>
                              </div>

                              <div className="row g-4 mb-4">
                                <div className="col-md-6">
                                  <div className="p-4 rounded-4 h-100 text-center" style={{ background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white' }}>
                                    <p className="mb-2" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                      <i className="fa fa-arrows-alt me-2"></i>Size of Container
                                    </p>
                                    <h3 className="mb-0 fw-bold" style={{ fontSize: '1.5rem', color: 'white' }}>
                                      {x.size_of_container || x.size || x.vehicles?.[0]?.size_of_container || jobDetails.size || 'N/A'}
                                    </h3>
                                    <p className="mb-0 mt-1" style={{ fontSize: '1rem', opacity: 0.9 }}>
                                      Type: {x.container_type || x.vehicles?.[0]?.container_type || 'N/A'}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="p-4 rounded-4 h-100 text-center" style={{ background: 'linear-gradient(135deg, #e8f5f5 0%, #d4efef 100%)', borderLeft: '6px solid #1daeb2' }}>
                                    <p className="mb-2" style={{ fontSize: '1.4rem', fontWeight: '700', color: '#1daeb2', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                      <i className="fa fa-cube me-2"></i>Item Title
                                    </p>
                                    <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.5rem' }}>
                                      {x.item_name || x.item_title || x.load_description || 'N/A'}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}




                {/* Cargo Category Details (Previously Tonnage) */}
                {jobDetails.category === 3 && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #01a8af',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-cubes"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Cargo Details
                      </h4>
                    </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                        <div className="row g-4 mb-4">
                          {/* 1. Cargo Category */}
                          <div className="col-md-3">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,118,121,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-list text-white" style={{ fontSize: '1.5rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-0" style={{ fontSize: '1.2rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Cargo Category</p>
                                    <h4 className="mb-0 fw-bold" style={{ color: '#007679', fontSize: '1.3rem' }}>
                                      {serviceData?.job?.category?.[jobDetails.category] ? capitalize(serviceData.job.category[jobDetails.category]) : 'N/A'}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* 2. Type of Cargo */}
                          <div className="col-md-3">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(1,168,175,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-cube text-white" style={{ fontSize: '1.5rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-0" style={{ fontSize: '1.2rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Type of Cargo</p>
                                    <h4 className="mb-0 fw-bold" style={{ color: '#01a8af', fontSize: '1.3rem' }}>
                                      {accessGeneralOrCargoType(jobDetails, serviceData) || 'N/A'}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* 3. Tonnage */}
                          {jobDetails.tonnage && jobDetails.tonnage !== 'N/A' && (
                            <div className="col-md-3">
                              <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(29,174,178,0.15)', overflow: 'hidden' }}>
                                <div className="card-body p-4">
                                  <div className="d-flex align-items-center">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)', flexShrink: 0 }}>
                                      <i className="fa fa-balance-scale text-white" style={{ fontSize: '1.5rem' }}></i>
                                    </div>
                                    <div>
                                      <p className="text-muted mb-0" style={{ fontSize: '1.2rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Tonnage</p>
                                      <h4 className="mb-0 fw-bold" style={{ color: '#1daeb2', fontSize: '1.3rem' }}>{jobDetails.tonnage}</h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* 4. Item Name */}
                          {jobDetails.single_item_title && jobDetails.single_item_title !== 'N/A' && (
                            <div className="col-md-3">
                              <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(41,190,193,0.15)', overflow: 'hidden' }}>
                                <div className="card-body p-4">
                                  <div className="d-flex align-items-center">
                                    <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', background: 'linear-gradient(135deg, #29bec1 0%, #33cfd4 100%)', flexShrink: 0 }}>
                                      <i className="fa fa-tag text-white" style={{ fontSize: '1.5rem' }}></i>
                                    </div>
                                    <div>
                                      <p className="text-muted mb-0" style={{ fontSize: '1.2rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Item Name</p>
                                      <h4 className="mb-0 fw-bold" style={{ color: '#29bec1', fontSize: '1.3rem' }}>{jobDetails.single_item_title}</h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="row g-4 mt-2">
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,118,121,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-info-circle text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Status</p>
                                    <h4 className="mb-0" style={{ color: '#007679', fontSize: '1.5rem', fontWeight: '700' }}>{getJobStatus(jobDetails, serviceData)}</h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(1,168,175,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #01a8af 0%, #1daeb2 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-calendar text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Expected Arrival</p>
                                    <h4 className="mb-0" style={{ color: '#01a8af', fontSize: '1.5rem', fontWeight: '700' }}>{moment(jobDetails.date_of_arrival).format('DD MMM YYYY') || 'N/A'}</h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="card border-0 h-100" style={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(29,174,178,0.15)', overflow: 'hidden' }}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-center">
                                  <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #1daeb2 0%, #29bec1 100%)', flexShrink: 0 }}>
                                    <i className="fa fa-ship text-white" style={{ fontSize: '1.8rem' }}></i>
                                  </div>
                                  <div>
                                    <p className="text-muted mb-1" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Port of Discharge</p>
                                    <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>{jobClearingPort}</h4>
                                    {jobDetails?.terminal_display && (
                                      <>
                                        <p className="text-muted mb-1 mt-3" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Terminal</p>
                                        <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>{jobDetails.terminal_display}</h4>
                                      </>
                                    )}
                                    {jobDetails?.shipping_line_display && (
                                      <>
                                        <p className="text-muted mb-1 mt-3" style={{ fontSize: '1.4rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>Shipping Line</p>
                                        <h4 className="mb-0" style={{ color: '#1daeb2', fontSize: '1.5rem', fontWeight: '700' }}>{jobDetails.shipping_line_display}</h4>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                )}

                {/* Documents Section */}
                {(jobDetails.paar_link ||
                  jobDetails.privateJobDocs?.lading_url ||
                  jobDetails.performa_invoice ||
                  jobDetails.marine_inspection_report) && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #1daeb2',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-file-text"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Documents
                      </h4>
                    </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                      <div className="row g-4">
                        {jobDetails.paar_link && (
                          <div className="col-lg-3 col-md-6">
                            <div
                              className="text-center p-4 rounded-4"
                              style={{
                                background: '#f8f9fa',
                                border: '2px solid #e0e0e0',
                                cursor: 'pointer',
                              }}
                              onClick={() => showDoc(jobDetails.paar_link)}
                            >
                              <i
                                className="fa fa-file-pdf-o mb-3"
                                style={{ fontSize: '3rem', color: '#007679' }}
                              ></i>
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: '1rem', color: '#2c3e50' }}
                              >
                                PAAR File
                              </p>
                            </div>
                          </div>
                        )}
                        {jobDetails.privateJobDocs?.lading_url && (
                          <div className="col-lg-3 col-md-6">
                            <div
                              className="text-center p-4 rounded-4"
                              style={{
                                background: '#f8f9fa',
                                border: '2px solid #e0e0e0',
                                cursor: 'pointer',
                              }}
                              onClick={() => showPrivateDoc(jobDetails.privateJobDocs)}
                            >
                              <i
                                className="fa fa-file-pdf-o mb-3"
                                style={{ fontSize: '3rem', color: '#01a8af' }}
                              ></i>
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: '1rem', color: '#2c3e50' }}
                              >
                                Bill of Lading
                              </p>
                              <span
                                className="d-inline-block mt-2"
                                style={{ fontSize: '0.85rem', color: '#01a8af', textDecoration: 'underline' }}
                                onClick={(e) => {
                                  // The tile itself opens the document; this
                                  // saves it. Without stopping the bubble both
                                  // would fire on one click.
                                  e.stopPropagation();
                                  savePrivateDoc(jobDetails.privateJobDocs);
                                }}
                              >
                                <i className="fa fa-download mr-1"></i> Download
                              </span>
                            </div>
                          </div>
                        )}
                        {jobDetails.performa_invoice && (
                          <div className="col-lg-3 col-md-6">
                            <div
                              className="text-center p-4 rounded-4"
                              style={{
                                background: '#f8f9fa',
                                border: '2px solid #e0e0e0',
                                cursor: 'pointer',
                              }}
                              onClick={() => showDoc(jobDetails.performa_invoice)}
                            >
                              <i
                                className="fa fa-file-pdf-o mb-3"
                                style={{ fontSize: '3rem', color: '#1daeb2' }}
                              ></i>
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: '1rem', color: '#2c3e50' }}
                              >
                                Proforma Invoice
                              </p>
                            </div>
                          </div>
                        )}
                        {jobDetails.marine_inspection_report && (
                          <div className="col-lg-3 col-md-6">
                            <div
                              className="text-center p-4 rounded-4"
                              style={{
                                background: '#f8f9fa',
                                border: '2px solid #e0e0e0',
                                cursor: 'pointer',
                              }}
                              onClick={() => showDoc(jobDetails.marine_inspection_report)}
                            >
                              <i
                                className="fa fa-file-pdf-o mb-3"
                                style={{ fontSize: '3rem', color: '#29bec1' }}
                              ></i>
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: '1rem', color: '#2c3e50' }}
                              >
                                Marine Report
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Transport Job Details */}
                {jobDetails.has_forwarding === 1 && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #007679',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-truck"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Transport Job Details
                      </h4>
                    </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                      {jobDetails?.forwarding_agent?.first_name && (
                        <div
                          className="mb-4 p-4 rounded-4"
                          style={{
                            background: 'linear-gradient(135deg, #e8f5f5 0%, #d4efef 100%)',
                            borderLeft: '6px solid #007679',
                          }}
                        >
                          <p
                            className="mb-2"
                            style={{
                              fontSize: '1.4rem',
                              fontWeight: '700',
                              color: '#007679',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                            }}
                          >
                            <i className="fa fa-user me-2"></i>Transporter Name
                          </p>
                          <h3
                            className="mb-0 fw-bold"
                            style={{ color: '#004d4d', fontSize: '1.5rem' }}
                          >
                            {jobDetails.forwarding_agent.first_name}{' '}
                            {jobDetails.forwarding_agent.last_name}
                          </h3>
                        </div>
                      )}
                      <div className="row g-4">
                        {serviceData?.port_locations?.[jobDetails?.port_of_discharge] && (
                          <div className="col-md-6">
                            <div
                              className="p-4 rounded-4"
                              style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                            >
                              <p
                                className="mb-2"
                                style={{
                                  fontSize: '1.2rem',
                                  fontWeight: '700',
                                  color: '#6c757d',
                                  textTransform: 'uppercase',
                                }}
                              >
                                <i className="fa fa-ship me-2"></i>Port of Discharge
                              </p>
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                              >
                                {startCase(
                                  camelCase(
                                    serviceData.port_locations[jobDetails.port_of_discharge],
                                  ),
                                ) || 'N/A'}
                              </p>
                            </div>
                          </div>
                        )}
                        {jobDetails?.destination && (
                          <div className="col-md-6">
                            <div
                              className="p-4 rounded-4"
                              style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                            >
                              <p
                                className="mb-2"
                                style={{
                                  fontSize: '1.2rem',
                                  fontWeight: '700',
                                  color: '#6c757d',
                                  textTransform: 'uppercase',
                                }}
                              >
                                <i className="fa fa-map-marker me-2"></i>Destination
                              </p>
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                              >
                                {jobDetails.destination || 'N/A'}
                              </p>
                            </div>
                          </div>
                        )}
                        <div className="col-md-6">
                          <div
                            className="p-4 rounded-4"
                            style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                          >
                            <p
                              className="mb-2"
                              style={{
                                fontSize: '1.4rem',
                                fontWeight: '700',
                                color: '#6c757d',
                                textTransform: 'uppercase',
                              }}
                            >
                              <i className="fa fa-map me-2"></i>State
                            </p>
                            <p
                              className="mb-0 fw-bold"
                              style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                            >
                              {serviceData.states.find(
                                (s) => s.uuid === jobDetails.destination_state,
                              )?.state || 'N/A'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Unbundled Jobs */}
                {jobDetails.children_packages && jobDetails.children_packages.length > 0 && (
                  <div
                    className="card border-0 mb-4"
                    style={{
                      borderRadius: '16px',
                      boxShadow: '0 8px 24px rgba(0,118,121,0.12)',
                      overflow: 'hidden',
                      background: '#ffffff',
                    }}
                  >
                    <div
                      className="card-header"
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        borderBottom: '3px solid #1daeb2',
                        padding: '1.5rem 2rem',
                      }}
                    >
                      <h4
                        className="mb-0"
                        style={{ color: '#ffffff', fontSize: '1.4rem', fontWeight: '700' }}
                      >
                        <i
                          className="fa fa-sitemap"
                          style={{ marginRight: '8px', color: '#ffffff' }}
                        ></i>
                        Unbundled Jobs
                      </h4>
                    </div>
                    <div className="card-body p-4" style={{ background: '#fafafa' }}>
                      {jobDetails.children_packages.map((x, index) => (
                        <div
                          key={index}
                          className={`mb-4 ${
                            index < jobDetails.children_packages.length - 1 ? 'pb-4' : ''
                          }`}
                          style={{
                            borderBottom:
                              index < jobDetails.children_packages.length - 1
                                ? '2px solid #e0e0e0'
                                : 'none',
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5
                              className="mb-0 fw-bold"
                              style={{ color: '#007679', fontSize: '1.5rem' }}
                            >
                              <i className="fa fa-cube me-2"></i>Job {index + 1}: {x.job_id}
                            </h5>
                          </div>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <div
                                className="p-3 rounded-4"
                                style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                              >
                                <p
                                  className="mb-1"
                                  style={{
                                    fontSize: '1.4rem',
                                    fontWeight: '700',
                                    color: '#6c757d',
                                    textTransform: 'uppercase',
                                  }}
                                >
                                  Size
                                </p>
                                <p
                                  className="mb-0 fw-bold"
                                  style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                >
                                  {capitalize(serviceData.truck.size[x.size])}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div
                                className="p-3 rounded-4"
                                style={{ background: '#f8f9fa', border: '2px solid #e0e0e0' }}
                              >
                                <p
                                  className="mb-1"
                                  style={{
                                    fontSize: '1.4rem',
                                    fontWeight: '700',
                                    color: '#6c757d',
                                    textTransform: 'uppercase',
                                  }}
                                >
                                  Weight
                                </p>
                                <p
                                  className="mb-0 fw-bold"
                                  style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                >
                                  {weightFormat(x.weight)}
                                </p>
                              </div>
                            </div>
                            <div className="col-12">
                              <div
                                className="p-4 rounded-4"
                                style={{
                                  background: 'linear-gradient(135deg, #f0f9f9 0%, #e0f2f2 100%)',
                                  border: '2px solid #01a8af',
                                }}
                              >
                                <h6
                                  className="fw-bold mb-3"
                                  style={{ color: '#01a8af', fontSize: '1.1rem' }}
                                >
                                  <i className="fa fa-truck me-2"></i>Truck Requirement
                                </h6>
                                <div className="row g-3">
                                  <div className="col-md-4">
                                    <p
                                      className="mb-1"
                                      style={{
                                        fontSize: '1.4rem',
                                        fontWeight: '700',
                                        color: '#6c757d',
                                      }}
                                    >
                                      Size
                                    </p>
                                    <p
                                      className="mb-0 fw-bold"
                                      style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                    >
                                      {x.truck.size}
                                    </p>
                                  </div>
                                  {jobDetails.category !== 3 && (
                                    <div className="col-md-4">
                                      <p
                                        className="mb-1"
                                        style={{
                                          fontSize: '1.2rem',
                                          fontWeight: '700',
                                          color: '#6c757d',
                                        }}
                                      >
                                        Hooks
                                      </p>
                                      <p
                                        className="mb-0 fw-bold"
                                        style={{ fontSize: '1.5rem', color: '#2c3e50' }}
                                      >
                                        {x?.no_of_hooks || 'N/A'}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Action Buttons */}
                {!userIsWorkSupervisor &&
                  jobDetails.children_packages &&
                  (jobDetails.clearing_status === '6' || jobDetails.clearing_status === '11') && (
                    <div className="text-center mb-4" style={{ paddingTop: '2rem' }}>
                      <div className="d-flex flex-wrap gap-3 justify-content-center">
                        <button
                          className="reject-job-btn-operator"
                          onClick={toggleRejectModal}
                          style={{
                            background: '#dc3545',
                            color: 'white',
                            borderRadius: '12px',
                            padding: '1rem 3.5rem',
                            fontSize: '1.25rem',
                            fontWeight: '700',
                            boxShadow: '0 4px 12px rgba(220,53,69,0.3)',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                        >
                          <i className="fa fa-times" style={{ marginRight: '8px' }}></i>Reject Job
                        </button>
                        {jobDetails.has_forwarding === 1 &&
                          jobDetails.no_of_containers >= 1 &&
                          jobDetails.children_packages.length <= 0 && (
                            <button
                              className="unbundle-job-btn-operator"
                              onClick={toggleUnBundelModal}
                              style={{
                                background: '#007679',
                                color: 'white',
                                borderRadius: '12px',
                                padding: '1rem 3.5rem',
                                fontSize: '1.25rem',
                                fontWeight: '700',
                                boxShadow: '0 4px 12px rgba(0,118,121,0.3)',
                                border: 'none',
                                cursor: 'pointer',
                              }}
                            >
                              <i className="fa fa-scissors" style={{ marginRight: '8px' }}></i>
                              Unbundle Job
                            </button>
                          )}
                        {showUpdateJob && (
                          <button
                            className="update-job-btn-operator"
                            onClick={() =>
                              props.history.push('/operator/job/update-service-request', {
                                ...jobDetails,
                              })
                            }
                            style={{
                              background: '#007679',
                              color: 'white',
                              borderRadius: '12px',
                              padding: '1rem 3.5rem',
                              fontSize: '1.25rem',
                              fontWeight: '700',
                              boxShadow: '0 4px 12px rgba(0,118,121,0.3)',
                              border: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            <i className="fa fa-edit" style={{ marginRight: '8px' }}></i>Update Job
                          </button>
                        )}
                        {canApprove() && (
                          <button
                            className="approve-job-btn-operator"
                            onClick={toggleApproveModal}
                            style={{
                              background: 'linear-gradient(135deg, #28a745 0%, #218838 100%)',
                              color: '#ffffff',
                              borderRadius: '12px',
                              padding: '1rem 3.5rem',
                              fontSize: '1.25rem',
                              fontWeight: '700',
                              boxShadow: '0 4px 12px rgba(40,167,69,0.3)',
                              border: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            <i className="fa fa-check" style={{ marginRight: '8px' }}></i>Approve
                          </button>
                        )}
                      </div>
                    </div>
                  )}

                {/* Payment Extension Buttons */}
                {(jobDetails.clearing_status === '9' || jobDetails.forwarding_status === '9') && (
                  <div className="text-center mb-4" style={{ paddingTop: '2rem' }}>
                    <div className="d-flex flex-wrap gap-3 justify-content-center">
                      <button
                        className="delete-job-btn-operator"
                        onClick={handleDeleteJob}
                        style={{
                          background: '#dc3545',
                          color: 'white',
                          borderRadius: '12px',
                          padding: '1rem 3.5rem',
                          fontSize: '1.25rem',
                          fontWeight: '700',
                          boxShadow: '0 4px 12px rgba(220,53,69,0.3)',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        <i className="fa fa-trash" style={{ marginRight: '8px' }}></i>Delete Job
                      </button>
                      {jobDetails.payment_extension &&
                        new Date(jobDetails.payment_extension).getTime() < new Date().getTime() && (
                          <button
                            className="extend-time-btn-operator"
                            onClick={toggleExtendTimeModal}
                            style={{
                              background: '#007679',
                              color: 'white',
                              borderRadius: '12px',
                              padding: '1rem 3.5rem',
                              fontSize: '1.25rem',
                              fontWeight: '700',
                              boxShadow: '0 4px 12px rgba(0,118,121,0.3)',
                              border: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            <i className="fa fa-clock-o" style={{ marginRight: '8px' }}></i>Extend
                            Time
                          </button>
                        )}
                    </div>
                  </div>
                )}

                {/* Assign Agent Button */}
                {(jobDetails.clearing_status === '10' || jobDetails.forwarding_status === '10') && (
                  <div className="text-center mb-4" style={{ paddingTop: '2rem' }}>
                    <button
                      className="btn btn-lg"
                      onClick={toggleAssignAgentModal}
                      style={{
                        background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)',
                        color: 'white',
                        borderRadius: '12px',
                        padding: '0.8rem 2rem',
                        fontSize: '1.1rem',
                        fontWeight: '700',
                        boxShadow: '0 4px 12px rgba(0,118,121,0.3)',
                      }}
                    >
                      <i className="fa fa-user-plus" style={{ marginRight: '8px' }}></i>Assign Agent
                    </button>
                  </div>
                )}

                {/* Back Button */}
                <div
                  className="back-button-container-operator"
                  style={{ paddingTop: '2rem', textAlign: 'center' }}
                >
                  <button
                    onClick={() => props.history.goBack()}
                    className="back-btn-operator"
                    style={{
                      background: '#007679',
                      color: 'white',
                      borderRadius: '12px',
                      padding: '1rem 3.5rem',
                      fontSize: '1.25rem',
                      fontWeight: '700',
                      boxShadow: '0 4px 12px rgba(0,118,121,0.3)',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    <i className="fa fa-arrow-left" style={{ marginRight: '8px' }}></i>Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <JobUnbundleModal
        isOpen={unBundleModal}
        toggle={toggleUnBundelModal}
        jobDetails={jobDetails}
        onUnbundle={onJobUnbundle}
      />

      {approveModal && (
        <JobApproveModal
          isOpen={approveModal}
          toggle={toggleApproveModal}
          jobDetails={jobDetails}
          onApprove={onJobApprove}
        />
      )}

      <RejectModal
        onSubmit={handleJobReject}
        isOpen={rejectModal}
        toggle={toggleRejectModal}
        container="client-page"
      />

      {!userIsWorkSupervisor && jobDetails.operator_comment && (
        <Chat
          name={chatName}
          chatbox={chatbox}
          user={user}
          chatToggle={chatToggle}
          chatlist={chatlist?.length > 0 ? chatlist : []}
          value={msg}
          handleTextChange={handleTextChange}
          handleOnChange={handleOnChange}
          sendButton={sendButton}
          unreadMsgsCount={unreadCount}
        />
      )}
      <ExtendPaymentTimeModal
        isOpen={extendTimeModal}
        toggle={toggleExtendTimeModal}
        onExtend={onExtendJobTime}
        jobDetails={jobDetails}
      />

      {assignAgentModal && (
        <AssignAgentToJobModal
          isOpen={assignAgentModal}
          toggle={toggleAssignAgentModal}
          jobDetails={jobDetails}
          onAssign={onAssignAgentToJob}
        />
      )}
    </>
  );
};

export default NewJobDetail;
